import { joditConfig } from '../joditConfig';
import React, { useState, useEffect } from 'react';
import { axios } from '../../config'
import JoditEditor from "jodit-react";
import Loading from '../loading'

const PagoEnvio = () => {

	const [data, setData] = useState({pagos_y_envios:''})
	const [loader, setLoader] = useState(true)

	useEffect(()=>{
		axios.get('/api/pagosenvios')
		.then(r=>{
			setData(r.data)
			setLoader(false)
		})
		.catch(r=>alert(r))
	},[])

	const _push = () => {

		const dataF = new FormData()
		dataF.append('pagos_y_envios', data.pagos_y_envios)

		axios.post('/api/pagosenvios', dataF)
		.then(r=>{
			alert('Las políticas para pagos y envios se han guardado satisfactoriamente')
		})
		.catch(r=>alert(r))
	}

	return(
		<div className='card-panel'>
			<h4>Pagos y envios</h4>
			{loader?
			<Loading />:
			<div className="row">
				<div className="input-field col s12">
					<JoditEditor value={data.pagos_y_envios} config={joditConfig} tabIndex={1} onBlur={newContent => setData({...data, pagos_y_envios:newContent})} />
				</div>
			</div>
			}
			<a href='#!' onClick={_push} className='btn waves-effect waves-light'>Guardar</a>
		</div>
	)
}

export default PagoEnvio
